import { Volume2, VolumeX } from 'lucide-react'
import { setSoundEnabled, useSoundEnabled } from '@/lib/sound'
import { TooltipIconButton } from './TooltipIconButton'
import { useMessages } from '@/i18n'
import { messages } from './messages'

/** Звуки прохождения в предпросмотре (как в плеере, `lib/sound.ts`): вкл/выкл. */
export const SoundToggleButton = () => {
  const soundOn = useSoundEnabled()
  const m = useMessages(messages)
  return (
    <TooltipIconButton
      icon={soundOn ? Volume2 : VolumeX}
      ariaLabel={soundOn ? m.soundOff : m.soundOn}
      onClick={() => setSoundEnabled(!soundOn)}
    />
  )
}
